import type { Honor, Milestone, TeamMember } from "@/types";

export const companyIntro = {
  name: "星光传媒",
  slogan: "让每一个好故事，都被看见",
  intro:
    "星光传媒是一家专注于影视内容制作与传播的综合型传媒机构。我们以电影、电视剧、综艺等多元内容为载体，致力于为观众带来有温度、有品质的作品，为合作伙伴提供专业、可靠的内容服务。",
  intro2:
    "自成立以来，星光传媒始终坚持“内容为本、创作立身”的理念，汇聚了一批经验丰富的导演、编剧、制片与运营人才，构建起从创意孵化到宣传发行的完整业务链条。",
  stats: [
    { value: "120+", label: "出品与参与作品" },
    { value: "18", label: "行业奖项荣誉" },
    { value: "9", label: "深耕影视行业（年）" },
    { value: "300+", label: "合作创作者" },
  ],
};

export const milestones: Milestone[] = [
  {
    year: "2017",
    title: "星光传媒成立",
    desc: "公司正式成立，以影视内容策划与制作为核心业务起步。",
  },
  {
    year: "2019",
    title: "首部院线电影上映",
    desc: "出品首部院线电影，正式进入电影制作与发行领域。",
  },
  {
    year: "2021",
    title: "布局剧集与综艺",
    desc: "成立剧集与综艺内容团队，业务版图进一步拓展。",
  },
  {
    year: "2023",
    title: "传媒服务中心成立",
    desc: "整合宣传发行与新媒体运营能力，构建全链路服务体系。",
  },
  {
    year: "2025",
    title: "作品屡获行业认可",
    desc: "多部作品在口碑与市场表现上取得突破，累计斩获多项行业奖项。",
  },
  {
    year: "2026",
    title: "青年人才培养计划",
    desc: "联合高校启动人才培养计划，为行业输送新生力量。",
  },
];

export const team: TeamMember[] = [
  {
    id: "t1",
    name: "苏渡",
    role: "首席内容官 / 导演",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20calm%20confident%20Chinese%20male%20film%20director%20in%20a%20dark%20shirt%2C%20clean%20soft%20neutral%20studio%20background%20with%20gentle%20warm%20lighting%2C%20editorial%20photography%2C%20high%20detail&width=500&height=600&seq=team-1&orientation=portrait",
    bio: "从事影视导演工作十余年，擅长宏大叙事与细腻情感的结合。",
  },
  {
    id: "t2",
    name: "陈墨",
    role: "签约导演",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20thoughtful%20Chinese%20male%20director%20with%20glasses%2C%20clean%20soft%20neutral%20studio%20background%20with%20gentle%20warm%20lighting%2C%20editorial%20photography%2C%20high%20detail&width=500&height=600&seq=team-2&orientation=portrait",
    bio: "专注悬疑与犯罪题材，代表作《暗流之城》口碑与热度双收。",
  },
  {
    id: "t3",
    name: "温言",
    role: "制片人",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20a%20warm%20elegant%20Chinese%20female%20film%20producer%2C%20clean%20soft%20neutral%20studio%20background%20with%20gentle%20warm%20lighting%2C%20editorial%20photography%2C%20high%20detail&width=500&height=600&seq=team-3&orientation=portrait",
    bio: "统筹多部剧集与电影项目，擅长把控项目节奏与制作质量。",
  },
  {
    id: "t4",
    name: "蓝调",
    role: "综艺内容总监",
    avatar:
      "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20an%20energetic%20Chinese%20male%20music%20show%20producer%2C%20clean%20soft%20neutral%20studio%20background%20with%20gentle%20warm%20lighting%2C%20editorial%20photography%2C%20high%20detail&width=500&height=600&seq=team-4&orientation=portrait",
    bio: "深耕综艺内容创作，主导多档音乐与竞演类节目的策划与制作。",
  },
];

export const honors: Honor[] = [
  { id: "h1", title: "年度优秀影视制作机构", year: "2025" },
  { id: "h2", title: "最佳视觉效果奖", year: "2025" },
  { id: "h3", title: "年度口碑剧集", year: "2024" },
  { id: "h4", title: "优秀新媒体内容奖", year: "2024" },
  { id: "h5", title: "行业创新实践奖", year: "2023" },
  { id: "h6", title: "青年创作扶持机构", year: "2023" },
];